<template>
  <form class="adress__form">
    <div class="adress__form-block">
      <slot name="top"/>
      <div class="adress__pickup-top">
        <div class="adress__title bottom">Наши рестораны</div>
        <div class="adress__pickup-list">
          <KpSelect
              v-model="city_selected"
              :options="cities"
              label="Город"
              trackBy="store_id"
              showBy="name"
              @input="(value) => { console.dir(value) }"
          />

        </div>
        <div style="width: 100%; margin-bottom: 15px; background: #e2e3e5; height: 1px"></div>
        <TheSpinner v-if="isLoading"/>
        <div v-else class="adress__pickup-list">
          <label v-for="pickup in localPickupList" class="adress__pickup-radio">
            <input @change="$emit('updateShipping', 'pickup.pickup', pickup.institution_id)" :value="pickup.institution_id" v-model="institution_id" type="radio" name="institution_id">
            <div class="adress__pickup-label">
              <div class="adress__pickup-left">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M12 21C15.5 17.4 19 14.1764 19 10.2C19 6.22355 15.866 3 12 3C8.13401 3 5 6.22355 5 10.2C5 14.1764 8.5 17.4 12 21Z"
                      stroke="#9A2B0B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path
                      d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z"
                      stroke="#9A2B0B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="adress__pickup-right">
                <div class="adress__pickup-title">{{ pickup.address }}</div>
                <div class="adress__pickup-time">{{ pickup.working_hours }}</div>
              </div>
            </div>
          </label>
        </div>
      </div>
      <slot name="bottom"/>
    </div>
  </form>
  <div class="adress__map" v-if="showMap">
      <ThePickupMap v-model:institution_id="institution_id" :injected-pickup-list="localPickupList"/>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import ThePickupMap from "@/components/element/order/shipping/ThePickupMap.vue";
import KpSelect from "@/components/form/Select.vue";
import ShippingSource from "@/api/ShippingSource.js";
import TheSpinner from "@/components/TheSpinner.vue";

export default {
  name: 'ThePickupShipping',
  components: {TheSpinner, KpSelect, ThePickupMap},
  props: {
    showMap: {
      default: true
    }
  },
  data() {
    return {
      city_selected: null,
      isLoading: false,
      localPickupList: [],
      institution_id: null,
      isMounted: false
    }
  },
  computed:{
    ...mapGetters({
      pickupListByCity: 'shipping/pickupListByCity',
      pickupList: 'shipping/pickupList'
    }),
    ...mapState({
      'shipping': state => state.shipping.shipping,
      'cities': state => state.city.cities,
      'currentCity': state => state.city.currentCity,
    }),
  },

  async mounted() {
    if(this.shipping?.code === 'pickup.pickup'){
      this.institution_id = this.shipping?.institution?.institution_id;
    }
    this.city_selected = this.currentCity?.store_id;
    this.localPickupList = JSON.parse(JSON.stringify(this.pickupList));

    if(!this.institution_id && this.localPickupList?.[0]?.['institution_id']){
      this.institution_id = this.localPickupList[0]['institution_id']
      this.$emit('updateShipping', 'pickup.pickup', this.institution_id)
    }

    this.$nextTick(() => {
      this.isMounted = true
    })
  },
  watch: {
    city_selected() {
      if (!this.isMounted) {
        return
      }

      if (this.city_selected === this.currentCity?.store_id) {
        this.city_selected = this.currentCity?.store_id;
        this.localPickupList = JSON.parse(JSON.stringify(this.pickupList));
        if(this.localPickupList?.[0]?.['institution_id']){
          this.institution_id =  this.localPickupList[0]['institution_id']
          this.$emit('updateShipping', 'pickup.pickup',  this.institution_id)
        }
        return;
      }
      this.loadLocalPickupList(this.city_selected);
    }
  },
  methods: {
    loadLocalPickupList(store_id) {
      this.localPickupList = this.pickupListByCity(store_id)

      if(this.localPickupList?.[0]?.['institution_id']){
        this.institution_id =  this.localPickupList[0]['institution_id']
        this.$emit('updateShipping', 'pickup.pickup',  this.institution_id)
      }
    }
  }

}
</script>
